import { useEffect, useState } from 'react';

type CurrencyKey = 'EUR' | 'USD' | 'MXN' | 'BRL';

export const useCurrencyOverride = (originalCurrency: CurrencyKey): CurrencyKey => {
  const [currency, setCurrency] = useState<CurrencyKey>(originalCurrency);

  useEffect(() => {
    // SECURITY: Only allow override in development environments
    if (!isDevEnvironment()) {
      setCurrency(originalCurrency);
      return;
    }
    
    // Check if there's a currency override in localStorage
    const overrideCurrency = localStorage.getItem('devtools_currency') as CurrencyKey;
    
    if (overrideCurrency && ['EUR', 'USD', 'MXN', 'BRL'].includes(overrideCurrency)) {
      setCurrency(overrideCurrency);
    } else {
      setCurrency(originalCurrency);
    }
  }, [originalCurrency]);

  return currency;
};

const isDevEnvironment = (): boolean => {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('beta') ||
    hostname.includes('staging') ||
    hostname.includes('dev') ||
    process.env.NODE_ENV === 'development'
  );
};

export const getCurrencyOverride = (originalCurrency: CurrencyKey): CurrencyKey => {
  // SECURITY: Only allow override in development environments
  if (!isDevEnvironment()) {
    return originalCurrency;
  }
  
  const overrideCurrency = localStorage.getItem('devtools_currency') as CurrencyKey;
  
  if (overrideCurrency && ['EUR', 'USD', 'MXN', 'BRL'].includes(overrideCurrency)) {
    return overrideCurrency;
  }
  
  return originalCurrency;
};
